module.exports = __webpack_public_path__ + "img/upload.84d5b598.svg";